import "./styles.scss";

import copy from "copy-to-clipboard";
import { useApp } from "hooks/app";
import PropTypes from "prop-types";
import React from "react";
import { AiOutlineLink } from "react-icons/ai";
import { IoChatbubblesOutline } from "react-icons/io5";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";

import { Button } from "@mui/material";

const ShareFallback = ({ onSuccess, title, text, url, buttonTitle, smsLink }) => {
  const { showAlert, social } = useApp();

  const onShareWindowClose = () => {
    onSuccess && onSuccess();
  };

  const onCopy = () => {
    if (url) {
      copy(`${url}`);
      onSuccess && onSuccess();
      showAlert({ message: `Link copied! To use it, open your email or message app and use the 'Paste' option.` });
    }
  };

  return (
    <div className="share-fallback">
      {smsLink && (
        <Button color="transparent" className="share-copy-button" href={smsLink} startIcon={<IoChatbubblesOutline />}>
          SEND TEXT MESSAGE
        </Button>
      )}
      <Button color="transparent" className="share-copy-button" onClick={onCopy} startIcon={<AiOutlineLink />}>
        <span>{buttonTitle}</span>
      </Button>
      <br />
      <div className="share-fallback-items">
        <EmailShareButton className="share-item" url={url} subject={title} body={text} onShareWindowClose={onShareWindowClose}>
          <EmailIcon size={40} round={true} />
        </EmailShareButton>
        <FacebookShareButton className="share-item" url={url} onShareWindowClose={onShareWindowClose}>
          <FacebookIcon size={40} round={true} />
        </FacebookShareButton>
        <FacebookMessengerShareButton
          className="share-item"
          url={url}
          onShareWindowClose={onShareWindowClose}
          appId={social.facebookAppId}
          redirectUri="https://facebook.com"
        >
          <FacebookMessengerIcon size={40} round={true} />
        </FacebookMessengerShareButton>
        <WhatsappShareButton className="share-item" url={url} onShareWindowClose={onShareWindowClose} title={title}>
          <WhatsappIcon size={40} round={true} />
        </WhatsappShareButton>
      </div>
    </div>
  );
};

ShareFallback.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  smsLink: PropTypes.string,
  onSuccess: PropTypes.func,
  buttonTitle: PropTypes.string
};

ShareFallback.defaultProps = {
  onSuccess: undefined,
  title: "",
  text: "",
  className: "",
  buttonTitle: "Copy Share Link"
};

export default ShareFallback;
